import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import {connectedRouterRedirect} from 'redux-auth-wrapper/history4/redirect';
import {USER_ACTIONS} from '../constants/users';
import {ROUTES} from '../configs/routes';

const locationHelper = locationHelperBuilder({});

export const auth = connectedRouterRedirect({
  allowRedirectBack: true,
  authenticatedSelector: (state) => !!state.rSession[USER_ACTIONS.LOGGED_IN],
  redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || ROUTES.LOGIN.route,
  wrapperDisplayName: 'UserIsAuthenticated',
});

export const notAuth = connectedRouterRedirect({
  allowRedirectBack: false,
  authenticatedSelector: (state) => !state.rSession[USER_ACTIONS.LOGGED_IN],
  redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || ROUTES.FEED.route,
  wrapperDisplayName: 'UserIsNotAuthenticated',
});

export const requireAuth = (decoratedComponent, accessParams = {}) => (
  connectedRouterRedirect({
    allowRedirectBack: false,
    authenticatedSelector: (state) => {
      const {roles, authLevels} = accessParams;
      const user = state.rUser || {};
      const userRole = user.role;
      const userAuthorityLevel = user.authorityLevel;
      const isValidRole = !roles.length ? true : roles.includes(userRole);
      const isAuthorityLevel = authLevels.includes(userAuthorityLevel);
      return isValidRole && isAuthorityLevel;
    },
    redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || ROUTES.FEED.route,
    wrapperDisplayName: 'UserIsNotHasAccess',
  })(decoratedComponent)
);
